<template>
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
    >
        <div id="page-user-list" class="div-with-loading vs-con-loading__container">
            <b-card>
                <div v-if="empresas.length>0" class="campanas-container custom-list-container">
                    <div style="border-bottom-width: 15px;" class="vx-row campana-div p-2" v-for="empresa in empresas" :key="empresa.id">
                        <b-row class="vx-row lg:w-2/5 w-full m-0">
                            <b-col lg="5" md="5" sm="12">
                                <b-row>
                                    <b-col cols="3" style="text-align: center; font-size: 30px; height: fit-content; background-color: transparent;">
                                        <font-awesome-icon icon="industry"/>
                                    </b-col>

                                    <b-col cols="9">
                                        <div class="">
                                            <router-link :to="'/administrador/empresas/editar/'+empresa.token_publico+'/'" v-b-tooltip.bottom="'Ver Detalle'">
                                                <p class="mb-1 campana-nombre" style="font-size: 18px; color: rgba(var(--vs-primary),1);"><strong>{{empresa.razon_social}}</strong></p>
                                            </router-link>
                                            <p>Ciudad: {{ empresa.ciudad }}</p>
                                            <p>Subdominio: <strong>{{ empresa.subdominio }}</strong></p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col lg="7" md="7" sm="12">
                                <b-row class="vx-row lg:w-3/5 w-full m-0">
                                    <b-col cols="4" class="text-center">
                                        <p>RUC</p>
                                        <h5 v-if="empresa.ruc" class="pt-1">{{ empresa.ruc }}</h5>
                                        <h4 v-else class="pt-1">-</h4>
                                    </b-col>
                                    <b-col cols="4"  class="text-center">
                                        <p>Correo</p>
                                      <h5 v-if="empresa.email" class="pt-1"><a :href="'mailto:'+empresa.email" target="_blank">{{empresa.email }}</a></h5>
                                        <h4 v-else class="pt-1">-</h4>
                                    </b-col>
                                    <b-col cols="4"  class="text-center">
                                        <p>Teléfono</p>
                                        <h5 v-if="empresa.telefono" class="pt-1">{{ empresa.telefono }}</h5>
                                        <h4 v-else class="pt-1">-</h4>
                                    </b-col>
                                </b-row>
                            </b-col>

                        </b-row>
                    </div>
                </div>

                <div v-else class="text-center mt-5 p-6">
                    <p>No hay registros para mostrar</p>
                </div>
            </b-card>
        </div>
    </b-overlay>
</template>


<script>
import axios from '@/axios';
export default {
    data(){
        return {
            empresas:[],
            mostrarLoader: false
        }
    },
    mounted(){
        this.obtenerEmpresas()
    },
    methods:{
        obtenerEmpresas(){
            this.openLoadingInDiv()
            axios.get('api/empresa/obtener-todas/').then(response =>{
                this.empresas = response.data.empresas
                this.closeLoadingInDiv()
            })
        },

        openLoadingInDiv(){
            this.mostrarLoader = true
        },

        closeLoadingInDiv(){
            this.mostrarLoader = false
        },
    },
}
</script>

<style scoped>
    .campanas-container .campana-div:not(:last-child){
        border-bottom: #f8f8f8 solid 5px;
    }
    .campana-nombre{
        cursor: pointer;
    }
    .campana-nombre:hover{
        color: #626262 !important;
    }
</style>
